<template>
	<div class="branch_page">
		<div class="position ">
			<div class="w1">当前位置：
				<router-link :to="'home'">首页</router-link>>
				<a style="text-decoration: none;">分会介绍</a>
				<!-- <a>分会介绍</a> -->
			</div>
		</div>

		<div class="w1"><!--w1 -->

			<div class="wrap_group1  mb_1"><!--wrap_group1 -->
				<div class="wrap_group1_L "><!--wrap_group1_L -->

					<div class="leftmenu"><!--leftmenu -->
						<div class="Nav  current">
							<l>分会介绍</l>
						</div>
						<ul class="subContent">
							<li class="on">
								<a>简介</a>
							</li>
							<li v-if="linkId&&branchLink" @click="jumppush(branchLink)">
								<a>链接</a>
							</li>
						</ul>
					
					</div><!--/leftmenu -->


				</div><!--/wrap_group1_L -->
				<div class="wrap_group1_R" v-loading="loadingMask"><!--wrap_group1_R -->


					<div class="main_title">{{articleTitle}}</div>

					<div class="main_title_info">发布日期：{{articleDate}}</div>

					<div class="main_text" v-html="articleHtml"><!--main_text -->
					</div><!--/main_text -->


				</div><!--/index_group1_R -->
			</div><!--/wrap_group1 -->



		</div><!--/w1 -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: true,
				articleId: '',
				articleTitle: '',
				articleDate: '',
				articleHtml: '',
				linkId:'',
				branchLink:'',
			}
		},
		components: {
	
		},
		watch: {
			$route(to, from) {
				if (to.query.id != from.query.id) {
					this.initPage();
				}
			}
		},
		created: function() {
			this.initPage();
		},
		mounted: function() {
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		methods: {
			initPage:function(){
				this.articleId=this.$route.query.id;
				this.linkId=this.$route.query.link;
				this.getArticle();
				if(this.linkId){
					this.getLink();
				}
			},
			jumppush:function(to){
				var a = document.createElement('a');
				a.setAttribute('href', to);
				a.setAttribute('style', 'display:none');  
				a.setAttribute('target', '_blank');  
				document.body.appendChild(a);
				a.click();
				a.parentNode.removeChild(a); 
			},
			getArticle: function() {
				this.loadingMask = true;
				var _this = this;
				this.$http({
						method: 'get',
						url: '/chinaculturalindustrypromotion/tbapparticleinfo/info/' + _this.articleId,
						responseType: 'json',
						params: {
			
						},
					})
					.then(function(response) {
						if (response.data.code == 0) {
							//console.log(response.data);
							_this.articleTitle = response.data.tbapparticleinfo.fdarticletitle;
							_this.articleDate = response.data.tbapparticleinfo.fdpublishtime.substring(0, 10);
							//处理视频和pdf
							var temphtml = response.data.tbapparticleinfo.fdhtmlcontent;
							if (process.env.NODE_ENV === 'development') {
								temphtml = temphtml.replace(/\/web\/tbappattachments/g, '/proxyapi/web/tbappattachments');
							}
							if (temphtml.indexOf("/web/tbappattachments/getFile?filetype=") > -1) {
								// debugger
								var regtaga = RegExp(/<a.*?a>/g);
								var temphtmlarr = temphtml.match(regtaga);
								if (temphtmlarr) {
									for (var i = 0; i < temphtmlarr.length; i++) {
										if (temphtmlarr[i].indexOf("filetype=video") > -1) {
											var regsrc = RegExp(/href="(.*?)"/);
											var tempsrc = regsrc.exec(temphtmlarr[i])[1];
											tempsrc = tempsrc.replace("getFile", "getVideo");
											temphtml = temphtml.replace(temphtmlarr[i], "<video controls='controls' width='100%' src='" +
												tempsrc + "'></video>");
										} else if (temphtmlarr[i].indexOf("filetype=pdf") > -1) {
											var regsrc = RegExp(/href="(.*?)"/);
											var tempsrc = regsrc.exec(temphtmlarr[i])[1];
											temphtml = temphtml.replace(temphtmlarr[i],
												"<iframe id='documentViewer' src='/pdfjs/web/viewer.html?file=" + encodeURIComponent(
													tempsrc) + "' style='width:100%;height:8rem;'></iframe>");
										}
									}
								}
							}
							_this.articleHtml = temphtml;
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						alert('数据获取出错！');
					});
			},
			getLink: function() {
				// this.loadingMask = true;
				var _this = this;
				this.$http({
						method: 'get',
						url: '/chinaculturalindustrypromotion/tbapparticleinfo/info/' + _this.linkId,
						responseType: 'json',
						params: {
			
						},
					})
					.then(function(response) {
						if (response.data.code == 0) {
							//console.log(response.data);
							_this.branchLink = response.data.tbapparticleinfo.fdcontent;
						// _this.loadingMask = false;
						}
					})
					.catch(function(error) {
						// _this.loadingMask = false;
						alert('数据获取出错！');
					});
			},
	
		}
	}
</script>

<style>
</style>